import { HumanIcon } from './HumanIcon';

/**
 * author: Google
 * id B05E458D-886A-491D-9969-156562C52105
 * name human
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/human.svg
 * tags
 * - People / Family 
 */
export const AccessibilityIcon = HumanIcon;
export default AccessibilityIcon